export default __webpack_public_path__ + "ba2c40f4269e502660e658009196eba0.svg";